/**
 * Converts a hex color string to a numeric color value.
 * Supports 3‑digit and 6‑digit hex codes, with or without a leading '#'.
 *
 * @param {string} hex - The hex color string (e.g., "#0f0", "00ff00", "00FF00").
 * @returns {number} The numeric representation (e.g., 0x00ff00 → 65280).
 * @throws {Error} If the input is not a valid hex color.
 */
export function hexToColorNumber(hex) {
  // Remove optional leading '#'
  let h = hex.replace(/^#/, '');

  // Expand 3‑digit shorthand (e.g., "0f0" → "00ff00")
  if (h.length === 3) {
    h = h.split('').map(c => c + c).join('');
  }

  // Validate length (must be 6 after expansion)
  if (h.length !== 6) {
    throw new Error(`Invalid hex color: "${hex}"`);
  }

  // Parse as base‑16 integer
  return parseInt(h, 16);
}